<template>
  <div style="
    position:absolute;
    left:0;top:0;bottom:0;right:0;overflow-y:scroll;
    margin-left:1rem;margin-top:2rem">
    <v-container >
        <v-form 
            ref="form"
            v-model="validForm"
            lazy-validation
        >
        <v-layout 
            row wrap 
            align-center 
            elevation-1 
            class="telemetry-container" 
            style="
                padding-left:1rem;
                padding-right:1rem;
                margin-bottom:1rem"
            >
            <v-flex xs12 sm12 md12>
                <v-combobox
                    v-model="selectedDevices"
                    label="Select devices"
                    :items="devices"
                    item-value="id"
                    item-text="attributes.customName"
                    multiple
                    chips
                    return-object
                    :rules="selectedDeviceRules"
                    required
                >
                <template v-slot:selection="data">
                    <v-chip
                    :key="JSON.stringify(data.item)"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    class="v-chip--select-multi"
                    @input="data.parent.selectItem(data.item)"
                    >
                    <v-avatar
                        class="accent" 
                    ><v-icon color="#EEEEEE" dark>memory</v-icon></v-avatar>
                    {{ data.item.attributes.customName }}
                    </v-chip>
                </template>
                </v-combobox>
            </v-flex>
        </v-layout>
        <!--
        <v-layout row wrap elevation-1 white align-center>
            <v-container>
                <v-layout  row wrap justify-space-around>
                    
                    <v-flex xs12 sm6 md3>
                        <v-select
                            prepend-icon="date_range"
                            v-model="selectedWindowTime"
                            label="Select window time"
                            :items="windowTimes"
                            item-value="id"
                            item-text="label"
                            return-object
                            :rules="windowTimeRules"
                            required
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            prepend-icon="access_time"
                            label="Start time"
                            v-bind:value="
                                (selectedStartTime.timeObj)?
                                    selectedStartTime.timeObj.toLocaleTimeString()+' - '+
                                    selectedStartTime.timeObj.toLocaleDateString()
                                :''
                            "
                            :disabled="(selectedWindowTime)?selectedWindowTime.id!=-1:true"
                            v-on:click="openDataPicker=true;selectedTime=selectedStartTime"
                            :rules="selectedTimeRules"
                            required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            prepend-icon="access_time"
                            label="End time"                          
                            v-bind:value="
                                (selectedEndTime.timeObj)?
                                    selectedEndTime.timeObj.toLocaleTimeString()+' - '+
                                    selectedEndTime.timeObj.toLocaleDateString()
                                :''
                            "
                            :disabled="(selectedWindowTime)?selectedWindowTime.id!=-1:true"
                            v-on:click="openDataPicker=true;selectedTime=selectedEndTime"
                            :rules="selectedTimeRules"
                            required
                        ></v-text-field>
                    </v-flex> 

                    <v-flex xs12 sm6 md2 >
                        <v-btn class="blue" icon dark v-on:click="submit" style="margin-top:1rem">
                            <v-icon>play_arrow</v-icon>
                        </v-btn>
                    </v-flex>

                    <v-dialog
                        ref="dialog"
                        v-model="openDataPicker"
                        persistent
                        lazy
                        full-width
                        width="290px"
                    >
                        <v-time-picker
                            v-model="selectedTime.time"
                            full-width
                        >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="openDataPicker = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="openDataPicker=false">OK</v-btn>
                        </v-time-picker>
                    </v-dialog>

                </v-layout>
            </v-container>
        </v-layout>-->
        </v-form>
        <v-layout row wrap align-center white elevation-1 style="margin-top:2rem;padding:1rem;" 
            class="telemetry-container" >
            <v-flex xs12 sm12 md12 style="position:relative">
                <div  v-if="selectedDevices.length==0"  style="
                    position:absolute;
                    top:0;bottom:0;width:100%;
                    border-style: dashed;border-width:0.3rem; border-color:grey;
                    background-color:white; opacity:0.5;
                    z-index:1;" >
                    <v-layout style="height:40rem" align-center justify-center>
                    <div style="color:grey"><v-icon big style="font-size:4rem" color="grey">map</v-icon> <h3> No devices selected </h3></div> 
                    </v-layout>
                </div>
                <MapView 
                    style="z-index:0" 
                    v-on:clickMap="()=>{}" 
                    v-on:clickMarker="()=>{}" 
                    v-on:clickPath="()=>{}" 
                    v-on:created="createdPolygonHandler"
                    :perimeters="currentPerimeters"
                    :markers="markers" 
                    :paths="paths" />
            </v-flex>
        </v-layout>
    </v-container>

    <v-snackbar
        :timeout="0"
        :value="geoLocationRealtime"
        :bottom="true"
        :right="true"
    >
        <v-progress-circular
            width="1.7"
            style="width:1.2rem;;margin-right:10px"
            indeterminate
            color="green"
        ></v-progress-circular>
      <span style="font-weight:bold">Listening geo-location data realtime</span>
        <v-btn icon dark v-on:click="stopGeoLocationRealtime">
            <v-icon>pause</v-icon>
        </v-btn>
    </v-snackbar>

    <inprogress  :dialog="operationInProcess" :message="operationInProcessMessage" ></inprogress>
  </div>
</template>
<script>
    import { mapState } from 'vuex'
    import Map from '@/components/GeofenceView'

    export default {

        name: "Map",
        
        components:{
            'MapView': Map
        },

        data: function(){
            return {
                validForm: false,
                selectedTimeRules: [
                    v => !!v || 'Time constrain required'
                ],
                windowTimeRules:[
                    v=> !!v || 'Window time required'
                ],
                selectedDeviceRules:[
                    v=> !!v || 'Select at least one device',
                    v => v.length>0 || 'Select at least one device'
                ],

                markers:[],
                paths: [],
                selectedDevices : [],
                openDataPicker: false,
                selectedWindowTime: null,
                selectedTime:{},
                selectedEndTime:{
                    timeObj:null,
                    time:""
                },
                selectedStartTime:{
                    timeObj:null,
                    time:""
                },    
                windowTimes:[
                    {
                        id:0,
                        label:"Realtime"
                    },
                    {
                        id:1,
                        label:"Last 1h"
                    },
                    {
                        id:3,
                        label:"3h"
                    },
                    {
                        id:6,
                        label:"6h"
                    },
                    {
                        id:-1,
                        label:"Custom"
                    }

                ],

                typeView: "paths",
                perimeters: [],
                currentPerimeters: []
            }
        },

        computed:{
            ...mapState(
                {
                    devices: state => state.devices.devices.filter(device=>device.configurationSignaled.measures!=null&&device.configurationSignaled.measures!=undefined),
                    geoLocations: state => state.telemetry.geoLocations ,
                    geoLocationRealtime: state => state.telemetry.listeningRelatime,
                    operationInProcess:'operationInProcess',
                    operationInProcessMessage: 'operationInProcessMessage'
                }
            )

        },

        watch:{
            selectedWindowTime(){
                this.buildWindowTime()
            },
            'selectedTime.time':function(){
                if(this.selectedTime.time&&this.selectedTime.time!=""){
                    this.selectedTime.timeObj = new Date()
                    let hhmm= this.selectedTime.time.split(':')
                    this.selectedTime.timeObj.setHours(parseInt(hhmm[0]))
                    this.selectedTime.timeObj.setMinutes(parseInt(hhmm[1]))             
                    this.selectedTime.timeObj.setSeconds(0)        
                }
            },
            
            geoLocations:{
                handler(){
                    this.buildGeoLocationsData()
                },
                deep: true
            },

            selectedDevices: function(){
                this.loadPerimetersOnMap()
                this.loadMarkersOnMap()
                // this.buildGeoLocationsData()
            }
        },

        async destroyed(){
            await 
                this
                .$store
                .dispatch('telemetry/stopGeoLocationRealtime')
        },

        async mounted () {
            await this.fetchPerimeters()
            this.
          devices
          .filter(d => d.configurationSignaled.data!=null&&d.configurationSignaled.data!=undefined)
          .filter(d=>d.configurationSignaled.data.geolocation!=null&&d.configurationSignaled.data.geolocation!=undefined)
          .filter(d=>d.id === this.selectedDevices.id)
          .map(d=> {
            //[todo: handle data at netowrk level]
            return {
              id:d.id,
              timestamp: d.configurationSignaled.data.timestamp?new Date(d.configurationSignaled.data.timestamp):new Date(),
              data:[{
                latitude: d.configurationSignaled.data.geolocation[0]?d.configurationSignaled.data.geolocation[0].value.latitude:undefined,
                longitude: d.configurationSignaled.data.geolocation[0]?d.configurationSignaled.data.geolocation[0].value.longitude:undefined,
                altitude: d.configurationSignaled.data.geolocation[0]?d.configurationSignaled.data.geolocation[0].value.altitude:undefined
              }]
            }
          })
          .forEach(
              geoLocationsDevice =>{
                for(let geoLocationIndex in geoLocationsDevice.data){
                    let geoLocation = geoLocationsDevice.data[geoLocationIndex]
                    let coordinates = {
                        latitude: geoLocation.latitude,
                        longitude: geoLocation.longitude,
                        altitude: geoLocation.altitude
                    }
                    let device = this.devices.find(d=>d.id==geoLocationsDevice.id);
                    let marker = {
                        id: geoLocationsDevice.id,
                        coordinates: coordinates,
                        htmlContentTooltip: getHtmlInfo(
                            device.attributes.technologyImage.image, 
                            device.attributes.customName,
                            device.id,
                            geoLocation.timestamp?new Date(geoLocation.timestamp):new Date(),
                            coordinates
                        )
                    }
                    this.markers.push(marker)
                }
              }
          )
        },

        methods:{
            // TODO: add dialog to validate user choises
            async createdPolygonHandler(e) {
                // window.console.log("createGeofence", e, this.selectedDevices);
                let perimeter = {devices: this.selectedDevices, points: e}
                // POST on AWS perimeter for selected devices
                await this.$store.dispatch('devices/createPerimeter', perimeter)
                .then(()=>{
                    this.fetchPerimeters()
                })
                .catch((err)=>{
                    this.$emit("abort",true)
                    throw err
                })
            },
            /*
            editedPolygonHandler(e) {
                // window.console.log("editGeofence", e, this.selectedDevices);
                //UPDATE on AWS perimeter for selected devices

            },

            deletedPolygonHandler(e) {
                // window.console.log("deleteGeofence", e, this.selectedDevices);
                //DELETE on AWS perimeter for selected devices

            },
            */
            async fetchPerimeters() {
                // window.console.log(this.devices)
                if (this.devices.length !== 0) {
                    await this.$store.dispatch('devices/fetchPerimeters', this.devices)
                    .then(data => this.perimeters = data)
                    .catch((err)=>{
                        this.$emit("abort",true)
                        throw err
                    })
                }
            },

            submit: async function(){
                this.validForm = this.$refs.form.validate()
                if (this.validForm) 
                {
                    if(this.geoLocationRealtime)
                        await 
                            this
                            .$store
                            .dispatch('telemetry/stopGeoLocationRealtime')

                    this.buildWindowTime()
                    await 
                        this
                        .$store
                        .dispatch(
                            (this.selectedWindowTime.id==0)?
                                'telemetry/startGeoLocationRealtime':
                                'telemetry/fetchGeoLocations',
                            {
                                devices:this.selectedDevices,
                                startTime:this.selectedStartTime.timeObj,
                                endTime:this.selectedEndTime.timeObj
                            }
                        )
                    return 
                }
            },

            stopGeoLocationRealtime: async function(){
                await 
                    this
                    .$store
                    .dispatch('telemetry/stopGeoLocationRealtime')
            },
            
            loadPerimetersOnMap: function() {
                // window.console.log('Selected devices: ', this.selectedDevices, ' , fetchedPerimeters: ', this.perimeters)
                this.currentPerimeters = []
                this.selectedDevices.forEach(device => {
                    let deviceId = device._id
                    // window.console.log(this.perimeters)
                    this.perimeters.forEach(perimeter => {
                        // window.console.log(perimeter)
                        if (perimeter[0] && perimeter[0].deviceId === deviceId) {
                            this.currentPerimeters.push(perimeter)
                        }
                    })
                })
            },

            loadMarkersOnMap: function() {
                this.markers = []
                // window.console.log('loadMarkersOnMap: ', this.selectedDevices, this.devices)
                this.
                selectedDevices
                .filter(d => d.configurationSignaled.data!=null&&d.configurationSignaled.data!=undefined)
                .filter(d=>d.configurationSignaled.data.geolocation!=null&&d.configurationSignaled.data.geolocation!=undefined)
                .map(d=> {
                    // window.console.log(d)
                    //[todo: handle data at netowrk level]
                    return {
                    id:d.id,
                    timestamp: d.configurationSignaled.data.timestamp?new Date(d.configurationSignaled.data.timestamp):new Date(),
                    data:[{
                        latitude: d.configurationSignaled.data.geolocation[0]?d.configurationSignaled.data.geolocation[0].value.latitude:undefined,
                        longitude: d.configurationSignaled.data.geolocation[0]?d.configurationSignaled.data.geolocation[0].value.longitude:undefined,
                        altitude: d.configurationSignaled.data.geolocation[0]?d.configurationSignaled.data.geolocation[0].value.altitude:undefined
                    }]
                    }
                })
                .forEach(
                    geoLocationsDevice =>{
                        for(let geoLocationIndex in geoLocationsDevice.data){
                            let geoLocation = geoLocationsDevice.data[geoLocationIndex]
                            let coordinates = {
                                latitude: geoLocation.latitude,
                                longitude: geoLocation.longitude,
                                altitude: geoLocation.altitude
                            }
                            let device = this.selectedDevices.find(d=>d.id==geoLocationsDevice.id);
                            let marker = {
                                id: geoLocationsDevice.id,
                                coordinates: coordinates,
                                htmlContentTooltip: getHtmlInfo(
                                    device.attributes.technologyImage.image, 
                                    device.attributes.customName,
                                    device.id,
                                    geoLocation.timestamp?new Date(geoLocation.timestamp):new Date(),
                                    coordinates,
                                    device.attributes.technologyImage.style
                                )
                            }
                            this.markers.push(marker)
                        }
                    }
                    )
            },

            buildGeoLocationsData: function(){
                this.markers.splice(0)
                this.paths.splice(0)

                this.geoLocations
                .filter(
                    geoLocationsDevice => 
                        this
                        .selectedDevices
                        .find( 
                            selectedDevice => selectedDevice.id == geoLocationsDevice.id
                        )
                )
                .forEach(
                    geoLocationsDevice =>{
                        if(!this.geoLocationRealtime)
                            for(let geoLocationIndex in geoLocationsDevice.data){
                                let geoLocation = geoLocationsDevice.data[geoLocationIndex]
                                let coordinates = {
                                    latitude: geoLocation.latitude,
                                    longitude: geoLocation.longitude,
                                    altitude: geoLocation.altitude
                                }
                                let device = this.devices.find(d=>d.id==geoLocationsDevice.id);
                                let marker = {
                                    id: geoLocationsDevice.id,//+geoLocation.timestamp,
                                    coordinates: coordinates,
                                    htmlContentTooltip: getHtmlInfo(
                                        device.attributes.technologyImage.image, 
                                        device.attributes.customName,
                                        device.id,
                                        geoLocation.timestamp, 
                                        coordinates
                                    )
                                }
                                if(this.typeView == "markers")
                                    this.markers.push(marker)
                                else
                                {
                                    let storedPath = this.paths.find( p => p.id == geoLocationsDevice.id)
                                    if(storedPath)
                                        storedPath.markers.push(marker)
                                    else
                                        this.paths.push({
                                            id: geoLocationsDevice.id,
                                            markers: [marker]
                                        })
                                }
                            }
                            else{
                                let geoLocation;
                                for(let geoLocationIndex in geoLocationsDevice.data)
                                    if(!geoLocation)
                                        geoLocation = geoLocationsDevice.data[geoLocationIndex]
                                    else if((geoLocation.timestamp.getTime()-geoLocationsDevice.data[geoLocationIndex].timestamp.getTime())<=0)
                                        geoLocation = geoLocationsDevice.data[geoLocationIndex]
                                if(geoLocation)
                                {
                                    let coordinates = {
                                        latitude: geoLocation.latitude,
                                        longitude: geoLocation.longitude,
                                        altitude: geoLocation.altitude
                                    }
                                    let device = this.devices.find(d=>d.id==geoLocationsDevice.id);
                                    let marker = {
                                        id: geoLocationsDevice.id,//+geoLocation.timestamp,
                                        coordinates: coordinates,
                                        htmlContentTooltip: getHtmlInfo(
                                            device.attributes.technologyImage.image, 
                                            device.attributes.customName,
                                            device.id,
                                            geoLocation.timestamp, 
                                            coordinates
                                        ),
                                        fitZoom:false
                                    }
                                    this.markers.push(marker)
                                }
                            }
                    }
                )

            },

            buildWindowTime(){
                let hours = this.selectedWindowTime.id
                switch(hours){
                    case 0:
                        this.selectedStartTime.timeObj = new Date()
                        this.selectedEndTime.timeObj = new Date()
                        break
                    case -1:
                        break
                    case null:
                        break
                    case undefined:
                        break
                    default:
                        this.selectedEndTime.timeObj = new Date()
                        this.selectedStartTime.timeObj = new Date(this.selectedEndTime.timeObj.getTime()-hours*60*60*1000)
                        return
                }
            }
        }
    }

function getHtmlInfo(img, customName, id, timestamp, coordinates){
    let title = `
        <div style="height:40px;align-content: left;">
        <img style="margin:-25px;transform:scale(0.5);float: left" src="${img}">
        <div style="float: left;margin:12px;margin-top:7px;align-content: left;">
            <div style="font-weight: bold">${customName}</div>
            <div>${id}</div>
        </div>
        </div>
    `
    let body = `
        <div style="height:100px;align-content: left;padding:10px">
        <div>
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >date_range</span>
                <span style="font-weight: bold;margin-left:15px">Timestamp:</span>
            </span> 
                ${timestamp.toString().split("GMT")[0]}
        </div>
        <div style="margin-top:3px">
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >my_location</span>
                <span style="font-weight: bold;margin-left:15px">Coordinates:</span>
            </span> 
            <div style="margin-left:25px">
                <div><span style="font-weight: bold">Latitude:</span> ${coordinates.latitude}</div>
                <div><span style="font-weight: bold">Longitude:</span>  ${coordinates.longitude}</div>
                <div><span style="font-weight: bold">Altitude:</span>  ${coordinates.altitude}</div>
            </div>
        </div>
        </div>
    `
    return {
        title: title,
        body: body
    }
}
</script>